







import Vue from 'vue'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

const chartAreaBorder = {
  id: 'chartAreaBorder',
  beforeDraw(chart:any, args:any, options:any) {
    const { ctx, chartArea: { left, top, width, height } } = chart;
    // Draw chart border
    ctx.save();
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.setLineDash(options.borderDash || []);
    ctx.lineDashOffset = options.borderDashOffset;
    ctx.strokeRect(left, top, width, height);
    ctx.fillStyle = 'white';
    ctx.fillRect(left, top, width, height);
    ctx.restore();
  }
}

const chartTotals = {
  id: 'chartTotals',
  beforeDraw(chart:any, args:any, options:any) {
    const { ctx, chartArea: { left, top, width, height } } = chart;
    if (chart.canvas.id === "livestockChart") {
      // render the value of the chart above the bar
      ctx.font = "bold 9px 'Helvetica Neue', Helvetica, Arial, sans-serif";
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      ctx.fillStyle = window.innerWidth < 768 ? 'transparent' : 'white';
      let visibleDatasets = chart._sortedMetasets.filter((ds:any, index:number) => ds.hidden === false || ds.hidden === null)
      // Dataset totals
      let totals:number[] = []
      let heights:number[] = []
      for (let period = 0; period < 24; period++) {
        let periodTotal = 0
        let heightTotal = 0
        for (let ix = 0; ix < visibleDatasets.length; ix++) {
          periodTotal += visibleDatasets[ix].controller._data[period] || 0
          if (visibleDatasets[ix].data[period] && ix === visibleDatasets.length - 1) {
            heightTotal = visibleDatasets[ix].data[period].y
          }
        }
        totals.push(Math.round(periodTotal))
        heights.push(heightTotal)
      }
      if (visibleDatasets.length > 0) {
        visibleDatasets[0].data.forEach((d:any, period:number) => {
          let posX = d.x;
          ctx.fillStyle = window.innerWidth < 768 ? 'transparent' : 'black';
          ctx.fillText(parseInt(totals[period].toFixed(0)), posX, heights[period] - 10);
        });
      }
    }
  }
}

export default Vue.component('chart', {
  data () {
    return {
      chart: null
    }
  },
  mounted (this:any) {
    setTimeout(() => {
      this.generateChart()
    }, this.loadTime)
  },
  props: {
    id: String,
    type: String,
    data: Object,
    options: Object,
    loadTime: Number // milliseconds
  },
  // Generate the chart using the passed properties
  // id, data and options - update data & options
  methods: {
    generateChart: function (this:any) {
      if (Vue.prototype['chart']) {
        Vue.prototype['chart'].destroy();
      }
      /*if (window['chart' as any]) {
        window['chart' as any].destroy();
        console.log('destroyed')
      }*/
      const ctx:any = document.getElementById(this.id)
      this.chart = new Chart(ctx, {
        type: this.type,
        data: this.data,
        options: this.options,
        plugins: [chartAreaBorder, chartTotals]
      })
      Vue.prototype['chart'] = this.chart;
      //window['chart' as any] = this.chart
      // console.log('created')
    },
  }
})
